<template>
  <b-card class="my-2 shadow rounded">
    <b-card-title><h1 class="text-md-center">Welcome</h1></b-card-title>
    <b-card-body>
      <p>
        A collaborative project with the Queensland Government Metro North Herston Infectious
        Diseases Institute (HeIDI) and CSIRO to provide a web-based tool for precision
        pharmaceutical dosing for ICU patients.
      </p>
      <p>
        Based on patient's data such as the creatinine clearance rate, the tool calculates the
        required pharmacokinetic parameters to provide optimal dosing regimens for use by clinicians
        in the ICU.
      </p>
      <hr />
      <b>Important Disclaimer</b>
      <p class="text-black-50">
        The results of the dosing calculator are intended to provide information for use by persons
        with clinical pharmaceutical training and knowledge of the management and interpretation of
        pharmaceutical dosing regimens. CSIRO makes the tool available on the understanding that you
        use it at your own risk and you exercise your own skill, judgement and care with respect to
        the suitability of the generated results for use within applicable therapeutic guidelines.
      </p>
      <p>
        Please refer to our
        <router-link to="terms">Terms of Use.</router-link>
      </p>
      <hr />
      <p>To register for a free account, please click Register or Login then "Sign up now".</p>
    </b-card-body>
    <b-card-footer>
      <b-button class="btn-lg bg-success" @click="login">Register or Login</b-button>
    </b-card-footer>
  </b-card>
</template>

<script setup lang="ts">
import { getCurrentInstance } from 'vue';
import { useToast } from 'vue-toastification';

defineOptions({ name: 'WelcomeComponent' });

const toast = useToast();
const { proxy } = getCurrentInstance()!;

// Navigates to B2C; the result is handled by the MSAL plugin when the app reloads
async function login() {
  try {
    await (proxy as any).$msal.login();
  } catch (e: any) {
    console.error(e);
    toast.error('Login failed. Please try again.');
  }
}
</script>

<style scoped>
.input-group span {
  width: 65%;
}

.custom-select option {
  text-align: left;
}
</style>
